import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'antd/dist/antd.css';
import { Upload, Modal } from 'antd';
import { Redirect } from 'react-router-dom';
import IntroduccioSelectorImatgeFenofase from './IntroduccioSelectorImatgeFenofase';
import styles from './IntroduccioIndividuFenofasesDetallImatge.module.css';
import {
  introduccioCrearFotoFenofaseIndividu,
  introduccioEliminarFotoFenofaseIndividu,
  errorConsultaServidor,
} from '../../actions';
import { MISSATGE_USUARI_NO_ACTIU } from '../../constantsFormularis';
import fotoNoTrobada from '../../images/fotoNoTrobada.jpg';
import { getUsuari } from '../../reducers';
import { fetchObtenirDadesUsuariPerIdObservador } from '../../actions/consultesServidor';
import configuracio from '../../configuracioEntorns';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class UploadFenofase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewVisible: false,
      previewImage: '',
      previewTitle: '',
      loading: false,
      fileList: [
        {
          uid: '-1',
          name:
            (props.especie ? props.especie + ' - ' : null) +
            (props.fenofase.nom ? props.fenofase.nom : null),
          status: 'done',
          url: props.fenofase.urlFotoIndividu
            ? props.fenofase.urlFotoIndividu
            : props.fenofase.urlFotoFenofase
            ? props.fenofase.urlFotoFenofase
            : '',
        },
      ],
      usuariNoActiu: false,
    };
  }

  gestioError = (error, tipusError) => {
    if (tipusError === MISSATGE_USUARI_NO_ACTIU) {
      this.setState({ usuariNoActiu: true });
    }
    this.props.errorConsultaServidor(error, tipusError);
  };

  eliminarImatgeSeleccionada = async () => {
    const dadesUsuari = await fetchObtenirDadesUsuariPerIdObservador(
      this.props.usuari.idObservador
    ).catch((error) => this.gestioError('Avís Error', error));

    if (dadesUsuari) {
      if (!dadesUsuari.actiu) {
        this.gestioError('Avís Error', MISSATGE_USUARI_NO_ACTIU);
      } else {
        const { fileList } = this.state;
        if (fileList[0].url === this.props.fenofase.urlFotoFenofase) {
          return false;
        } else {
          const { onDisableComponent } = this.props;
          onDisableComponent(true);

          //Borrar imagen S3
          const resultat = await this.props.eliminarFoto(
            this.props.fenofase.urlFotoIndividu
          );
          //Si error, deixar imatge actual
          if (!resultat.resposta) {
            return false;
          }
          onDisableComponent(false);
        }
      }
    }
  };

  handleCrearFoto = async (urlFoto) => {
    const { onDisableComponent } = this.props;
    onDisableComponent(true);
    this.props.crearFoto(urlFoto);

    const imagen = await getBase64(urlFoto.fitxer);

    let newFileList = [...this.state.fileList];
    newFileList[0].url = imagen;
    this.setState(() => {
      return { fileList: newFileList };
    });
    onDisableComponent(false);
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
    });
  };

  handleChange = ({ file, fileList }) => {
    const props = this.props;
    if (file.status === 'error') {
      fileList = [
        {
          uid: '-1',
          name:
            (props.especie ? props.especie + ' - ' : null) +
            (props.fenofase.nom ? props.fenofase.nom : null),
          status: 'error',
          url: fotoNoTrobada,
        },
      ];
    }

    if (fileList.length === 0) {
      fileList = [
        {
          uid: '-1',
          name:
            (props.especie ? props.especie + ' - ' : null) +
            (props.fenofase.nom ? props.fenofase.nom : null),
          status: 'done',
          url: props.fenofase.urlFotoFenofase
            ? props.fenofase.urlFotoFenofase
            : fotoNoTrobada,
        },
      ];
    }
    this.setState({ fileList });
  };

  render() {
    const { fenofase, onDisableComponent } = this.props;
    const {
      previewVisible,
      previewImage,
      fileList,
      previewTitle,
      usuariNoActiu,
    } = this.state;

    if (usuariNoActiu) {
      const urlBase = configuracio.ruta;
      return <Redirect to={`${urlBase}/login`} />;
    }
    return (
      <div>
        <Upload
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          accept="image/gif,image/jpeg,image/jpg,image/png,image/bmp"
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          onRemove={this.eliminarImatgeSeleccionada}
          onDisableComponent={onDisableComponent}
          onLoad={() => {
            window.dispatchEvent(new Event('resize'));
          }}
        />

        {fileList[0].url === this.props.fenofase.urlFotoFenofase ? (
          <IntroduccioSelectorImatgeFenofase
            className={styles.IntroduccioFoto}
            urlImatgeOriginal={null}
            fenofase={fenofase}
            crearFoto={this.handleCrearFoto}
          />
        ) : null}

        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    );
  }
}

class IntroduccioIndividuFenofasesDetallImatge extends Component {
  state = {
    show: false,
    updateFotoEnCurs: false,
  };

  showModal = () => {
    this.setState({
      show: true,
    });
  };

  handleClose = () => {
    this.setState({
      show: false,
    });
  };

  render() {
    const {
      fenofase,
      especie,
      introduccioEliminarFotoFenofaseIndividu,
      introduccioCrearFotoFenofaseIndividu,
      onDisableComponent,
    } = this.props;

    return (
      <div>
        <UploadFenofase
          eliminarFoto={introduccioEliminarFotoFenofaseIndividu}
          crearFoto={introduccioCrearFotoFenofaseIndividu}
          fenofase={fenofase}
          especie={especie}
          onDisableComponent={onDisableComponent}
          usuari={this.props.usuari}
          errorConsultaServidor={this.props.errorConsultaServidor}
        />
      </div>
    );
  }
}

IntroduccioIndividuFenofasesDetallImatge.propTypes = {
  fenofase: PropTypes.object.isRequired,
  introduccioEliminarFotoFenofaseIndividu: PropTypes.func.isRequired,
  introduccioCrearFotoFenofaseIndividu: PropTypes.func.isRequired,
  onDisableComponent: PropTypes.func.isRequired,
  usuari: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    usuari: getUsuari(state),
  };
};

const mapDispatchToProps = {
  introduccioEliminarFotoFenofaseIndividu,
  introduccioCrearFotoFenofaseIndividu,
  errorConsultaServidor,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IntroduccioIndividuFenofasesDetallImatge);
